import { DateRangeValidationError } from '@mui/x-date-pickers-pro';
import { DateRangeValuePiece } from './DateRangePickerMui';
import { DateTimeRangeValidationError } from '@mui/x-date-pickers-pro/models/validation';
import { endOfDay, getYear, isValid } from 'date-fns';

export const MIN_POSSIBLE_DATE = new Date('01/01/2000');

export const basicErrorHandling = (
  currentRange: [DateRangeValuePiece, DateRangeValuePiece],
  error: DateRangeValidationError | DateTimeRangeValidationError,
  minDate?: DateRangeValuePiece,
  maxDate?: DateRangeValuePiece,
): [DateRangeValuePiece, DateRangeValuePiece] => {
  if (
    (error[0] === 'minDate' && (error[1] === 'maxDate' || error[1] === 'disableFuture')) ||
    ((error[0] === 'maxDate' || error[0] === 'disableFuture') && error[1] === 'minDate')
  ) {
    return [minDate || MIN_POSSIBLE_DATE, maxDate || new Date()];
  }
  if (
    (error[0] === 'maxDate' || error[0] === 'disableFuture') &&
    (error[1] === 'maxDate' || error[1] === 'disableFuture')
  ) {
    return [maxDate || new Date(), maxDate || new Date()];
  }
  if (error[0] === 'minDate' && error[1] === 'minDate') {
    return [minDate || MIN_POSSIBLE_DATE, minDate || MIN_POSSIBLE_DATE];
  }
  if (error[0] === 'maxDate' || error[0] === 'disableFuture') {
    return [maxDate || new Date(), maxDate || new Date()];
  }
  if (error[1] === 'maxDate' || error[1] === 'disableFuture') {
    return [currentRange[0], maxDate || new Date()];
  }
  return currentRange;
};

export const isDateValid = (date: Date | number) => {
  return isValid(date) && getYear(date) && getYear(date) > 1970;
};

export const parseDateToRequest = (date: Date | null | undefined) => {
  if (!date) {
    return null;
  }

  return isDateValid(date) ? date.toISOString() : null;
};

export const parseDateEndOfDayToRequest = (date: Date | null | undefined) => {
  if (!date) {
    return null;
  }

  return isDateValid(date) ? endOfDay(date).toISOString() : null;
};
